import React, {useEffect} from 'react';
import {Box, Stack} from "@mui/material";
import {useQueryClient} from "@tanstack/react-query";
import {
    IVoceSchedaCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceSchedaCosto";
import {useToast} from "../../../../../../../utils/contexts/toast-context";
import {Controller, useForm} from "react-hook-form";
import useApiCreateVoceSchedaCosto from "./api-hooks/useApiCreateVoceSchedaCosto";
import useApiUpdateVoceSchedaCosto from "./api-hooks/useApiUpdateVoceSchedaCosto";
import useApiGetVoceSchedaCostoDetail from "./api-hooks/useApiGetVoceSchedaCostoDetail";
import MuiInputTextField from "../../../../../../ui/mui/mui-input/MuiInputTextField";
import SaveOrBackForm from "../../../../../../ui/common_components/SaveOrBackForm";
import VociCostoSelect from "../../voci_costo/VociCostoSelect";
import {useTanneryProduction} from "../../../../../../../utils/contexts/tannery_production/tannery_production-context";


interface Props {
    objToEdit: IVoceSchedaCosto | null | undefined;
    onClose: () => void;
    onSelect?: (obj: IVoceSchedaCosto | undefined) => void,
    scheda_costo_id: number | undefined;
}

const VociSchedaCostoForm: React.FC<Props> = ({objToEdit, onClose, scheda_costo_id, onSelect}) => {
    const {selectedCompanyOrderSchedule,} = useTanneryProduction()
    const {displayMessage, displayError} = useToast();
    const queryClient = useQueryClient();
    const {control, handleSubmit, setValue} = useForm<IVoceSchedaCosto>({});

    const createMutation = useApiCreateVoceSchedaCosto(scheda_costo_id);
    const updateMutation = useApiUpdateVoceSchedaCosto(scheda_costo_id);

    const [isActive, setIsActive] = React.useState(false);

    const {
        data: detailedObj,
    } = useApiGetVoceSchedaCostoDetail(scheda_costo_id, objToEdit?.id);

    useEffect(() => {
        if (detailedObj) {
            Object.entries(detailedObj).forEach(([key, value]) => {
                setValue(key as keyof IVoceSchedaCosto, value);
            });
        }

    }, [detailedObj, setValue]);

    const onSubmit = async (formData: IVoceSchedaCosto) => {
        const mutation_data = {
            ...formData,
            scheda_costo_id: scheda_costo_id,
            voce_scheda_costo_id: formData.voce_scheda_costo?.id ?? null
        };

        try {
            if (detailedObj) {
                await updateMutation.mutateAsync({
                    id: detailedObj.id,
                    data: mutation_data
                });
                await queryClient.invalidateQueries({queryKey: ["useApiGetVoceSchedaCostoDetail", scheda_costo_id, detailedObj.id]});
                displayMessage('updated successfully');
            } else {
                await createMutation.mutateAsync(mutation_data);
                displayMessage('added successfully');
            }
            onClose();
            await queryClient.invalidateQueries({queryKey: ['useApiGetVociSchedaCosto', scheda_costo_id]});
            await queryClient.invalidateQueries({queryKey: ['useApiGetSchedaCostoDetail', selectedCompanyOrderSchedule?.id]});
        } catch (error) {
        }
    };


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{padding: 2, minWidth: 400}}>

                <Stack direction={{xs: "column", md: "row"}} spacing={2}>
                    <Box flex={1}>
                        <Controller
                            name="row_position"
                            control={control}
                            render={({field}) => (
                                <MuiInputTextField
                                    label="posizione"
                                    type="number"
                                    {...field}
                                />
                            )}
                        />
                    </Box>
                    <Box flex={1}>
                        <Controller
                            name="value"
                            control={control}
                            render={({field}) => (
                                <MuiInputTextField
                                    label="costo"
                                    type="text"
                                    {...field}
                                />
                            )}
                        />
                    </Box>

                </Stack>

                <Stack direction={{xs: "column", md: "row"}} spacing={2}>
                    <Box flex={1}>
                        {/*<VociCostoSelect obj={undefined}*/}
                        {/*                 onChange={(obj) => {*/}
                        {/*                 }}*/}
                        {/*                 className={''}*/}
                        {/*/>*/}

                        <Controller
                            name="voce_scheda_costo"
                            control={control}
                            render={({field}) => (
                                <VociCostoSelect
                                    label="voce"
                                    obj={field.value}
                                    onChange={(obj) => {
                                        field.onChange(obj);
                                    }}
                                    className={''}
                                    required={true}
                                />
                            )}
                        />
                    </Box>

                </Stack>


                <Stack spacing={2}>
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1}}>
                        <SaveOrBackForm
                            onSubmit={onSubmit}
                            onClose={onClose}
                            handleSubmit={handleSubmit}
                        />
                    </Box>

                </Stack>
            </Box>


        </form>
    );
};

export default VociSchedaCostoForm;